import React from 'react';
import './body.css';
import MAP from '../../assests/images/global-map.jpg'

export const Body = () => {
  return (
    <div className="body-wrapper">
      <div className="overlay">
        <div className="content text-center text-white">
          <h1 className="display-5 fw-bold">Understand Global Crisis with AI-Powered Insight</h1>
          {/* <button className="btn btn-primary mt-4 px-4 py-2">Explore Dashboard</button> */}
        </div>
      </div>
    </div>
  );
};
